<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> Sentencia <span *ngIf="action == 'Delete'"> {{LOCAL_DATA.nombre}}</span></h1>
<div mat-dialog-content fxLayout="column">

  <div fxFlex>
    <mat-form-field fxFlex>
      <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre">
    </mat-form-field>
  </div>
  <div fxFlex>
    <mat-form-field fxFlex>
      <textarea placeholder="Descripcion" matInput [(ngModel)]="LOCAL_DATA.descripcion"></textarea>
    </mat-form-field>
  </div>

  <div fxFlex *ngIf="tablasDeEvaluacion.length>0">
    <mat-form-field  fxFlex>
      <mat-label>Tabla de evaluacion</mat-label>
      <mat-select [(ngModel)]="LOCAL_DATA.tablaDeEvaluacion" class="roleSelect" [compareWith]="compareObjects" >
        <ng-container *ngFor="let tabla of tablasDeEvaluacion">
          <mat-option  [value]="tabla">
            {{tabla.nombre}} | {{tabla.descripcion}}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()" [disabled]="LOCAL_DATA.nombre==null || LOCAL_DATA.nombre=='' || (tablasDeEvaluacion.length>0 && LOCAL_DATA.tablaDeEvaluacion==null)">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
